/**
 * Project data for the portfolio.
 *
 * Required fields:
 * @property {string} id - Unique identifier (camelCase, used as React key)
 * @property {string} title - Display name of the project
 * @property {string} description - 2-3 sentence description of what the project does
 * @property {string[]} techStack - Array of 4-6 technology names, ordered by prominence
 * @property {string} role - Role/context line (e.g., "Solo full-stack project")
 *
 * Optional fields:
 * @property {string|null} liveUrl - Full HTTPS URL to live demo, or null if self-hosted
 * @property {Object|null} media - Media object with type discriminator, or null
 * @property {string} media.type - "image" or "video"
 * @property {string} media.url - URL to the media resource
 */

export const projects = [
  {
    id: 'gainsLog',
    title: 'GainsLog',
    description: 'A full-stack workout tracking app where users log exercises, track sets, reps, and weight over time, and visualize their progress with interactive charts. Built to replace spreadsheet-based tracking with a purpose-built tool that surfaces trends and personal records automatically.',
    techStack: ['React', 'TypeScript', 'Fastify', 'PostgreSQL', 'Chart.js', 'Docker'],
    role: 'Solo full-stack project',
    liveUrl: 'https://workout.rooshhil.com',
    media: null,
  },
  {
    id: 'codeNames',
    title: 'CodeNames',
    description: 'A real-time multiplayer word game where players split into two teams, take turns giving one-word clues, and guess which words on a shared board belong to their team. Supports multiple concurrent game rooms with live state synchronization across all connected players.',
    techStack: ['React', 'TypeScript', 'Fastify', 'Socket.io', 'Redis', 'Docker'],
    role: 'Solo full-stack project',
    liveUrl: 'https://codenames.rooshhil.com',
    media: null,
  },
  {
    id: 'aiNotesManager',
    title: 'AINotesManager',
    description: 'An AI-powered knowledge management system that automatically organizes notes, generates summaries, and enables semantic search across personal documents. Uses vector embeddings to find conceptually related content regardless of exact keyword matches.',
    techStack: ['Python', 'n8n', 'Gemini', 'Qdrant', 'FastAPI', 'Docker'],
    role: 'Solo AI/automation project',
    liveUrl: null, // Self-hosted, no public demo
    media: null, // Supports { type: 'image'|'video', url: '...' } when media is added
  },
];
